/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * Personal data delete modal windows selector.
 *
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.17.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { initialPersonalDataDeleteState } from './personalDataDeleteConstants';
import { IPersonalDataDeleteReducer } from './personalDataDeleteReducer';

const personalDataDeleteState = (state: IRootReducer): IPersonalDataDeleteReducer =>
    state.personalDataDelete || initialPersonalDataDeleteState;

export const makeSelectPersonalDataDeleteOrderId = ():
    OutputSelector<IRootReducer, string, (state: IPersonalDataDeleteReducer) => string> =>
    createSelector(
        personalDataDeleteState,
        (state: IPersonalDataDeleteReducer) => state.orderId,
    );
